import { Link } from "react-router-dom";
import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed. Watch your inbox for our next note.");
      setEmail("");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-midnight text-white/90 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-6 bg-white/95 rounded-lg p-3 inline-block">
            <img src="/logo.webp" alt="Manigriv Financial Services" className="h-12 w-auto" />
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            A trusted partner for wealth management, mutual fund advisory, and corporate financial structuring — SEBI registered, fee-only, based in Delhi.
          </p>
          <form onSubmit={subscribe} className="mt-8 flex gap-2 max-w-md" data-testid="footer-newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="footer-newsletter-input"
              className="flex-1 bg-white/5 border border-white/15 rounded-full px-5 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-gold"
            />
            <button data-testid="footer-newsletter-submit" disabled={loading} className="btn-gold text-sm disabled:opacity-60">
              {loading ? "…" : "Subscribe"}
            </button>
          </form>
        </div>

        <div>
          <div className="overline text-gold mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-gold" to="/about">About</Link></li>
            <li><Link className="hover:text-gold" to="/services">Services</Link></li>
            <li><Link className="hover:text-gold" to="/calculators">Calculators</Link></li>
            <li><Link className="hover:text-gold" to="/insights">Insights</Link></li>
            <li><Link className="hover:text-gold" to="/team">Team</Link></li>
            <li><Link className="hover:text-gold" to="/careers">Careers</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-gold mb-4">Reach us</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li>New Delhi, India</li>
            <li><a href="tel:+917300838191" className="hover:text-gold">+91 73008 38191</a></li>
            <li><a href="mailto:manigrivfinancial@gmail.com" className="hover:text-gold">manigrivfinancial@gmail.com</a></li>
            <li>Mon–Sat · 9:30–18:30</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between text-xs text-white/50">
        <p>© {new Date().getFullYear()} Manigriv Financial Services. All rights reserved.</p>
        <p className="mt-2 md:mt-0">Investments are subject to market risks. Read all documents carefully.</p>
      </div>
    </footer>
  );
}
